/* eslint-disable react-refresh/only-export-components */
import { machineTrackingService, scenarioHubService } from '@/api/hub'
import MachineTrackingStore from '@/stores/machineTrackingStore'
import ScenarioStore from '@/stores/scenarioStore'
import { QueryClient, useQueryClient } from '@tanstack/react-query'
import React, { createContext, useContext } from 'react'

class RootStore {
  machineTrackingStore
  scenarioStore

  constructor(queryClient: QueryClient) {
    this.machineTrackingStore = new MachineTrackingStore(
      machineTrackingService,
      queryClient
    )
    this.scenarioStore = new ScenarioStore(scenarioHubService, queryClient)
  }
}

const rootStore: RootStore | null = null

export const StoreContext = createContext<RootStore | null>(null)

export const StoreProvider = ({ children }: { children: React.ReactNode }) => {
  const queryClient = useQueryClient() // <-- Correct way

  // Use a ref to persist the store instance across renders
  const storeRef = React.useRef<RootStore>()
  if (!storeRef.current) {
    storeRef.current = new RootStore(queryClient)
  }

  return (
    <StoreContext.Provider value={storeRef.current}>
      {children}
    </StoreContext.Provider>
  )
}

export const useStore = () => {
  const store = useContext(StoreContext)
  if (!store) {
    throw new Error('useStore must be used within a StoreProvider')
  }
  return store
}

export const useMachineTrackingStore = () => {
  const { machineTrackingStore } = useStore()
  return machineTrackingStore
}

export const useScenarioStore = () => {
  const { scenarioStore } = useStore()
  return scenarioStore
}

export default rootStore
